import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { LoadIndicator } from 'devextreme-react/load-indicator'
import axios from 'axios'

interface FrequentForm {
	folder: string
	model: string
	usage_count: number
	text: string
	desc?: string
	dashboard?: any
	filter?: string
}

export default function FrequentForms() {
	const [frequentForms, setFrequentForms] = useState<FrequentForm[]>([])
	const [loading, setLoading] = useState(true)

	useEffect(() => {
		loadFrequentForms()
	}, [])

	const loadFrequentForms = async () => {
		try {
			setLoading(true)
			const response = await axios.get(`${API_FIBER_URL}/forms/frequent`)
			if (response.data.success) {
				setFrequentForms(response.data.frequent_forms)
			}
		} catch (error) {
			console.error('Error loading frequent forms:', error)
		} finally {
			setLoading(false)
		}
	}

	const getModelUrl = (form: FrequentForm) => {
		let url = form.dashboard === '1' ? '/dashboard' : '/m'
		url = `${url}?folder=${form.folder}&model=${form.model}`
		if (form.filter) {
			url = `${url}&filter=${form.filter}`
		}
		return url
	}
	if (loading) {
		return (
			<div className={'content-block'}>
				<LoadIndicator height={20} width={20} />
			</div>
		)
	}

	if (frequentForms.length === 0) {
		return null
	}

	return (
		<div className={'content-block'}>
			<h5 style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '8px' }}>
				My Frequent Forms
			</h5>
			<div className={'gridView'}>
				{frequentForms.map((form, index) => (
					<Link
						key={`${form.folder}-${form.model}`}
						className="modelCard"
						to={getModelUrl(form)}
						style={{ position: 'relative' }}
					>
						<div className={'textWrapper'}>
							<p style={{ fontSize: '16px', marginBottom: '0' }}>{form.text}</p>
							{form.desc && <p style={{ marginTop: '2px', fontSize: '12px' }}>{form.desc}</p>}
							<p style={{ fontSize: '11px', color: '#666', marginTop: '8px' }}>
								{form.folder} • Used {form.usage_count} time{form.usage_count !== 1 ? 's' : ''}
							</p>
						</div>
					</Link>
				))}
			</div>
		</div>
	)
}
